// extracted by mini-css-extract-plugin
export var author = "industryItem-module--author--2476f";
export var category = "industryItem-module--category--b1707";
export var headline = "industryItem-module--headline--f495f";
export var headlinePost = "industryItem-module--headline-post--c0e95";
export var icon = "industryItem-module--icon--2def8";
export var iconContainer = "industryItem-module--iconContainer--10f1d";
export var industryItem = "industryItem-module--industryItem--70df6";
export var industryLink = "industryItem-module--industryLink--3358a";
export var paragraph = "industryItem-module--paragraph--c94ea";
export var title = "industryItem-module--title--12732";